const mantineHtmlProps = {
  suppressHydrationWarning: true,
  "data-mantine-color-scheme": "light"
};

export { mantineHtmlProps };
//# sourceMappingURL=mantine-html-props.mjs.map
